import { EasmScanConfigurationController } from '../controller/EasmScanConfigurationController';
import { BaseWebComponentElement } from '../../../../framework/BaseWebComponentElement';

export class EasmScanConfigurationWebComponent extends BaseWebComponentElement {
  public companyId: string;
  public controller: EasmScanConfigurationController | null;

  constructor(companyId: string) {
    super();
    this.initialSetup({
      controllerConstructor: EasmScanConfigurationController,
    });
    this.companyId = companyId;
  }

  public setCompanyId(companyId: string): void {
    this.controller?.setCompanyIdOnView(companyId);
  }
}
